import { Combo } from "./combo";
import { IComboConfig } from "../types";
import { isEmptyObj } from "@dhx/ts-common/core";
import { ProCombobox } from "@dhx/ts-combobox";
import { awaitRedraw } from "@dhx/ts-common/dom";

export class ProCombo extends Combo {
	constructor(container, config: IComboConfig) {
		super(container, config);
	}
	protected _initView(config: IComboConfig): void {
		if (isEmptyObj(config)) {
			throw new Error("Check the configuration is correct");
		}
		if (this.combobox) {
			this.combobox.destructor();
		}
		this.config = {
			type: config.type,
			id: config.id,
			name: config.name,
			disabled: false,
			hidden: false,
			value: "",
			readOnly: false,
			template: undefined,
			filter: undefined,
			multiselection: false,
			selectAllButton: false,
			itemsCount: undefined,
			itemHeight: 32,
			virtual: false,
			listHeight: 224,
			required: false,
			validation: undefined,
			placeholder: "",
			label: "",
			labelWidth: "",
			labelPosition: "top",
			hiddenLabel: false,
			helpMessage: "",
			preMessage: "",
			successMessage: "",
			errorMessage: "",
			width: "content",
			height: "content",
			padding: undefined,
		};
		const comboConfig = {};
		for (const key in config) {
			if (key !== "id" && key !== "type" && key !== "name") {
				this.config[key] = config[key];
				if (key !== "validation") {
					comboConfig[key] = config[key];
				}
			}
		}

		this.combobox = new ProCombobox(null, comboConfig);

		if (this.config.hidden) {
			awaitRedraw().then(() => {
				this.hide(true);
			});
		}
		this.paint();
	}
}
